// `.env.ts` is generated by the `npm run env` command
import env from './.env';

export const environment = {
  production: true,
  version: env.npm_package_version,
  serverUrl: '/v1',
  isMock: false,
  defaultLanguage: 'en-US',
  supportedLanguages: [
    'en-US',
  ],
  recaptchaSiteKey: '', // Set at runtime in production. See config.service.ts
};
